import {
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    ListItemButton,
    Box,
    Toolbar,
    useTheme,
    useMediaQuery,
    Divider,
    Tooltip,
    Typography
} from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import { Dashboard, People, Description, Notifications, NoteAdd } from '@mui/icons-material';

const menuItems = [
    { text: 'Tableau de bord', icon: <Dashboard />, path: '/dashboard' },
    { text: 'Gestion des clients', icon: <People />, path: '/dashboard/clients' },
    { text: 'Gestion des documents', icon: <Description />, path: '/dashboard/documents' },
    { text: 'Gestion plan comptable', icon: <Description />, path: '/dashboard/plan', match: /^\/dashboard\/(?:clients\/[^/]+\/)?plan\/?$/ },
    { text: 'Notifications', icon: <Notifications />, path: '/dashboard/notifications' },
    { text: 'Certification TEJ', icon: <NoteAdd />, path: '/dashboard/certification' },
];

const SidebarMenu = ({ onItemClick }) => {
    const location = useLocation();
    const navigate = useNavigate();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    // ✅ tient compte d’un éventuel item.match (RegExp)
    const isActiveItem = (item) => {
        if (item.match instanceof RegExp) return item.match.test(location.pathname);
        return location.pathname === item.path;
    };

    return (
        <>
            <Toolbar sx={{ justifyContent: 'center', py: 3 }}>
                <Box
                    sx={{
                        width: 160,
                        height: 160,
                        borderRadius: '50%',
                        marginTop: '-30px',
                        overflow: 'hidden',
                        border: `2.5px solid ${theme.palette.secondary.main}`,
                        boxShadow: '0 0 18px rgba(241, 196, 15, 0.35)',
                        transition: 'transform 0.3s ease-in-out',
                        '&:hover': { transform: 'scale(1.05)' },
                    }}
                >
                    <img
                        src="/logo.jpg"
                        alt="Logo"
                        style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                    />
                </Box>
            </Toolbar>

            <Divider sx={{ my: 1 }} />

            <List>
                {menuItems.map((item) => {
                    const active = isActiveItem(item);
                    return (
                        <Tooltip key={item.text} title={item.text} placement="right" arrow disableHoverListener={!isMobile}>
                            <ListItem disablePadding sx={{ px: 2 }}>
                                <ListItemButton
                                    onClick={() => {
                                        navigate(item.path);
                                        onItemClick?.();
                                    }}
                                    selected={active}
                                    sx={{
                                        borderRadius: 2,
                                        my: 0.5,
                                        transition: 'background-color 0.3s ease',
                                        bgcolor: active ? 'rgba(241, 196, 15, 0.18)' : 'transparent',
                                        '&:hover': {
                                            backgroundColor: 'rgba(241, 196, 15, 0.08)',
                                        },
                                        '&.Mui-selected': {
                                            backgroundColor: 'rgba(241, 196, 15, 0.18)',
                                            '& .MuiListItemIcon-root': {
                                                color: theme.palette.secondary.main,
                                            },
                                            '& .MuiTypography-root': {
                                                fontWeight: 600,
                                                color: theme.palette.text.primary,
                                            },
                                        },
                                    }}
                                >
                                    <ListItemIcon sx={{ color: 'text.secondary', minWidth: 36 }}>
                                        {item.icon}
                                    </ListItemIcon>
                                    <ListItemText
                                        primary={
                                            <Typography variant="body1" noWrap>
                                                {item.text}
                                            </Typography>
                                        }
                                    />
                                </ListItemButton>
                            </ListItem>
                        </Tooltip>
                    );
                })}
            </List>
        </>
    );
};

export default SidebarMenu;
